import React from "react";
import ReactStars from "react-rating-stars-component";

import styles from "./Review.module.css";

function ReviewRating({ reviews = [] }) {
  return (
    <div className={`${styles.cart_mains} `}>
      {reviews.map((i) => (
        <div key={i.id} className={styles.review_container}>
          {i.user_id?.avatar ? (
            <img
              src={i.user_id.avatar}
              className={styles.circle}
              alt="avatar"
            />
          ) : (
            <div className={styles.circle}>
              {i.user_id?.first_name?.slice(0, 1)}
            </div>
          )}
          <div style={{ flex: 1 }}>
            <div className={styles.review_title}>
              <div>
                <h2 className={styles.header}>
                  {i.user_id?.first_name} {i.user_id?.last_name}
                </h2>
              </div>
              <div style={{ display: "flex" }}>
                <p style={{ margin: "8px 5px", fontWeight: "bold" }}>
                  {i.rating}
                </p>
                <ReactStars
                  count={5}
                  onChange={() => {}}
                  size={24}
                  activeColor="#ffd700"
                  edit={false}
                  value={i.rating}
                />
              </div>
            </div>
            <p className={styles.review_content}>{i.feedback}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReviewRating;
